const UploadIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0007 7.50008V1.66675L8.33398 3.33341"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 1.66675L11.6667 3.33341"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.65039 10.8333H5.32539C5.64206 10.8333 5.92539 11.0083 6.06706 11.2916L7.04206 13.2416C7.32539 13.8083 7.90039 14.1666 8.53372 14.1666H11.4754C12.1087 14.1666 12.6837 13.8083 12.9671 13.2416L13.9421 11.2916C14.0837 11.0083 14.3754 10.8333 14.6837 10.8333H18.3171"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.83268 4.2749C2.88268 4.70824 1.66602 6.44157 1.66602 9.9999V12.4999C1.66602 16.6666 3.33268 18.3332 7.49935 18.3332H12.4993C16.666 18.3332 18.3327 16.6666 18.3327 12.4999V9.9999C18.3327 6.44157 17.116 4.70824 14.166 4.2749"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export { UploadIcon };
